var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Effect, Actions } from '@ngrx/effects';
import { AuthService } from '../../auth.service';
import * as authAction from '../actions/auth.actions';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { Observable } from 'rxjs/Observable';
var AuthEffect = /** @class */ (function () {
    function AuthEffect(actions, auth) {
        var _this = this;
        this.actions = actions;
        this.auth = auth;
        this.loginUser = this.actions.ofType(authAction.LOGIN_USER)
            .map(function (action) { return action.payload; })
            .pipe(switchMap(function (user) {
            return _this.auth.signIn(user).map(function (_user) {
                if (_user.accountType === 'admin') {
                    return new authAction.LoginUserSuccess(_user);
                }
                else {
                    _this.auth.signOut();
                    return new authAction.LoginUserFail('Access denied');
                }
            }).catch(function (error) { return of(new authAction.LoginUserFail('Invalid Login Credentials')); });
        }));
        this.logoutUser = this.actions.ofType(authAction.LOGOUT_USER)
            .map(function () {
            _this.auth.signOut();
            return new authAction.LogoutUser();
        });
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], AuthEffect.prototype, "loginUser", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Observable)
    ], AuthEffect.prototype, "logoutUser", void 0);
    return AuthEffect;
}());
export { AuthEffect };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/store/effects/auth.effect.ts.pre-build-optimizer.js